export default __webpack_public_path__ + "static/logo-c568c0e6da2482737ace66361584e440.png";